import { render, staticRenderFns } from "./LocationsManagement.vue?vue&type=template&id=c2de826c&scoped=true&"
import script from "./LocationsManagement.vue?vue&type=script&lang=ts&"
export * from "./LocationsManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2de826c",
  null
  
)

export default component.exports